import PortTypeSelector from 'components/selectors/PortTypeSelector';
import PortSizeSelector from 'components/selectors/PortSizeSelector';
import AreaSelector from 'components/selectors/AreaSelector';

import edit from 'assets/svg/actions/edit.svg';
import archive from 'common/assets/svg/actions/archive.svg';
import unarchive from 'common/assets/svg/actions/unarchive.svg';
import mapIcon from 'assets/svg/components/map/show-map.svg';
import { isLatAllowed } from 'views/enums/ports/form/port/helpers';
import TextWithTooltip from 'common/components/general/TextWithTooltip';
import CountrySelector from 'common/components/selectors/CountrySelector';
import { initializeTimezone } from 'views/enums/ports/form/helpers';
import { getPortSize } from 'views/enums/ports/form/helpers';
import NamesInTooltip from '@/library/components/general/NamesInTooltip';

export const portsColumns = [
  {
    header: 'ID',
    key: 'id',
    type: 'string',
    minWidth: 60,
    maxWidth: 60,
    className: 'text-start',
    canFilter: false,
    sort: true
  },
  {
    header: 'Name',
    key: 'name',
    type: 'string',
    minWidth: 200,
    maxWidth: 200,
    className: 'text-start',
    sort: true
  },
  {
    header: 'Name Synonym',
    key: 'name_synonyms',
    type: 'string',
    sort: false,
    minWidth: 170,
    maxWidth: 170,
    className: 'text-start',
    canFilter: false
  },
  {
    header: 'Country',
    key: 'country_id',
    type: 'collection',
    component: CountrySelector,
    componentRest: { isMulti: true },
    sort: false,
    minWidth: 130,
    maxWidth: 130,
    className: 'text-start',
    canFilter: true
  },
  {
    header: 'Area',
    key: 'area',
    canFilter: false,
    minWidth: 145,
    maxWidth: 145,
    sort: true
  },
  {
    header: 'Code',
    key: 'code',
    type: 'string',
    minWidth: 115,
    maxWidth: 115,
    className: 'text-start',
    sort: true
  },
  {
    header: 'Code Synonym',
    key: 'code_synonyms',
    type: 'string',
    canFilter: false,
    className: 'text-start',
    minWidth: 115,
    maxWidth: 115,
    sort: false
  },
  {
    header: 'Timezone',
    key: 'timezone',
    type: 'string',
    canFilter: false,
    minWidth: 120,
    maxWidth: 120,
    className: 'text-start',
    sort: true
  },
  {
    header: 'Is Bunkering',
    key: 'is_bunkering',
    type: 'boolean',
    options: [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' }
    ],
    className: 'text-start',
    minWidth: 115,
    maxWidth: 115,
    sort: true
  },
  {
    header: 'Max sulfur (%)',
    key: 'max_sulfur',
    type: 'number',
    minWidth: 125,
    maxWidth: 125,
    className: 'text-start',
    sort: true
  },
  {
    header: (
      <div className="d-flex align-items-center">
        <div>COORDINATES</div>
        <div className="text-violet cms-4">LAT/LNG</div>
      </div>
    ),
    key: 'coordinates',
    type: 'string',
    width: 2,
    className: 'text-start',
    canFilter: false,
    minWidth: 222,
    maxWidth: 222
  },
  {
    header: 'Type',
    key: 'type',
    type: 'string',
    className: 'text-start',
    sort: true,
    canFilter: false,
    minWidth: 120,
    maxWidth: 120
  },
  {
    header: 'Type',
    key: 'port_type_id',
    type: 'collection',
    sort: false,
    canFilter: true,
    component: PortTypeSelector,
    componentRest: { isMulti: true },
    hidden: true
  },
  {
    header: 'Size',
    key: 'size',
    type: 'collection',
    className: 'text-start',
    component: PortSizeSelector,
    componentRest: { isMulti: true },
    sort: true
  },
  {
    header: 'Area',
    key: 'port_area_id',
    type: 'collection',
    component: AreaSelector,
    componentRest: { isMulti: true },
    className: 'd-none',
    canReorder: false
  },
  {
    header: 'Actions',
    key: 'actions',
    field: 'actions',
    className: 'text-center'
  }
];

export const portsMapColumns = [
  {
    header: 'ID',
    key: 'id',
    type: 'string',
    minWidth: 72,
    maxWidth: 72,
    className: 'text-start',
    canFilter: false,
    sort: true
  },
  {
    header: 'Name',
    key: 'name',
    type: 'string',
    minWidth: 360,
    maxWidth: 360,
    className: 'text-start',
    sort: true
  },
  {
    header: 'Code',
    key: 'code',
    type: 'string',
    minWidth: 145,
    maxWidth: 145,
    className: 'text-start',
    sort: true
  },
  {
    header: 'Timezone',
    key: 'timezone',
    type: 'string',
    canFilter: false,
    minWidth: 90,
    maxWidth: 90,
    className: 'text-end me-7',
    sort: true
  },
  {
    header: 'LAT',
    key: 'lat',
    type: 'numberInput',
    field: 'numberInput',
    minWidth: 169,
    maxWidth: 169,
    canFilter: false
  },
  {
    header: 'LON',
    key: 'lon',
    type: 'numberInput',
    field: 'numberInput',
    minWidth: 169,
    maxWidth: 169,
    canFilter: false
  },
  {
    header: 'Area',
    key: 'area',
    type: 'listSelect',
    field: 'listSelect',
    canFilter: false,
    sort: true
  },
  {
    header: 'Type',
    key: 'type',
    type: 'listSelect',
    field: 'listSelect',
    canFilter: false,
    sort: true
  }
];

export const portRows = ({ setActive, toggleMap, drawer, sizeOptions }) => ({
  is_bunkering: data => <div>{data.is_bunkering ? 'YES' : 'NO'}</div>,
  code_synonyms: data =>
    data.code_synonyms && data.code_synonyms.length > 0 ? (
      <NamesInTooltip
        numberOfElements={2}
        target={`enums-table-code-synonyms-${data.id}`}
        names={data.code_synonyms.map(code => code)}
        customElement={data.code_synonyms.slice(0, 2) + ' '}
      />
    ) : (
      '-'
    ),
  size: data => {
    return data?.size ? (
      <TextWithTooltip className="h-auto">
        {getPortSize(sizeOptions, data.size, true)}
      </TextWithTooltip>
    ) : (
      '-'
    );
  },
  country_id: data => (
    <TextWithTooltip className="h-auto">{data.country?.name || '-'}</TextWithTooltip>
  ),
  name: data => <TextWithTooltip className="h-auto">{data?.name || ''}</TextWithTooltip>,
  area: data => <TextWithTooltip className="h-auto">{data?.area?.name || ''}</TextWithTooltip>,
  code: data => <TextWithTooltip className="h-auto">{data?.code || ''}</TextWithTooltip>,
  type: data =>
    data?.type?.name ? (
      <TextWithTooltip className="h-auto">{data?.type?.name || ''}</TextWithTooltip>
    ) : (
      '-'
    ),
  port_area_id: data => data?.area?.name || '',
  timezone: data => (
    <TextWithTooltip className="h-auto">
      {initializeTimezone(data.timezone)?.label || ''}
    </TextWithTooltip>
  ),
  name_synonyms: data =>
    data.name_synonyms && data.name_synonyms.length > 0 ? (
      <NamesInTooltip
        numberOfElements={2}
        target={`enums-table-name-synonyms-${data.id}`}
        names={data.name_synonyms.map(name => name)}
        customElement={data.name_synonyms.slice(0, 2) + ' '}
      />
    ) : (
      '-'
    ),
  coordinates: data => (
    <div className="d-flex align-items-center">
      <div>{data.lat}</div>

      {data.lat || data.lon ? <div className="cms-4 cme-4">/</div> : null}

      <div>{data.lon}</div>
    </div>
  ),
  actions: data => ({
    options: [
      {
        label: data.is_archived ? 'Unarchive' : 'Archive',
        icon: data.is_archived ? unarchive : archive,
        isArchived: data.is_archived,
        modal: true,
        header: data.is_archived ? 'Unarchive' : 'Archive',
        body: (
          <div className="text-center">
            You are about to {data.is_archived ? 'unarchive' : 'archive'} this port. <br />
            Are you sure you want to continue?
          </div>
        )
      },
      {
        label: 'Edit',
        icon: edit,
        onClick: (_, row) => {
          setActive(row);
          drawer.open();
        }
      },
      {
        label: 'Map',
        className: 'text-primary',
        icon: mapIcon,
        onClick: (_, row) => {
          toggleMap(true);
          setActive(row);
        }
      }
    ]
  })
});

export const portMapRows = ({ onCellSave, setActive }) => ({
  lat: () => ({
    onSave: onCellSave,
    decimalScale: 9,
    isAllowed: isLatAllowed
  }),
  lon: () => ({
    onSave: onCellSave,
    decimalScale: 9,
    isAllowed: isLatAllowed
  }),
  area: data => ({
    list: 'port-areas',
    overrideKey: 'port_area_id',
    onSave: onCellSave
  }),
  type: () => ({
    list: 'port-types',
    overrideKey: 'port_type_id',
    onSave: onCellSave
  })
});

export const portMapTopFilters = {
  filters: [
    {
      name: 'port_area_id',
      operation: 'oneOf',
      value: null
    },
    {
      name: 'country_id',
      operation: 'oneOf',
      value: null
    }
  ]
};
